import styled from 'styled-components'

export const AnswersSection = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const Answer = styled.div<{ $form?: boolean }>(({ theme, $form }) => ({
  backgroundColor: $form ? theme.colors.white : theme.colors.gray100,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['8'],
  marginBottom: theme.space['12'],
  padding: theme.space['12'],
  transition: `background-color ${theme.transition.duration.md}`,
}))

// Note: flow-root keeps the card's bottom margin inside the slot, so the Collapse height includes it
export const NewAnswerSlot = styled.div(() => ({
  display: 'flow-root',
}))

export const AnswerBody = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
}))

export const AnswerActions = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.space['12'],
  justifyContent: 'flex-end',
}))

export const AnswerButtons = styled.div(({ theme }) => ({
  display: 'flex',
  flexShrink: 0,
  gap: theme.space['8'],
}))

export const AnswerHeader = styled.div(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
}))

export const EmptySlot = styled.div(() => ({
  display: 'grid',
}))

export const EmptyLayer = styled.div<{ $stretch?: boolean; $visible: boolean }>(
  ({ theme, $stretch, $visible }) => ({
    alignItems: $stretch ? 'stretch' : 'center',
    display: 'flex',
    gridArea: '1 / 1',
    justifyContent: 'center',
    opacity: $visible ? 1 : 0,
    pointerEvents: $visible ? 'auto' : 'none',
    transition: `opacity ${theme.transition.duration.md}`,
    visibility: $visible ? 'visible' : 'hidden',
  }),
)

// Note: same box as an answer card, so the empty state looks like the cards it will be replaced by
// Note: the answer card as the form of a new answer - fills the slot and has no gap below
export const AnswerForm = styled(Answer)(() => ({
  marginBottom: 0,
  width: '100%',
}))

export const EmptyCard = styled(Answer)(() => ({
  // Note: drops the EmptyState's own padding - the card around it already provides the spacing
  '> div': { padding: 0 },
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 0,
  width: '100%',
}))
